import React from 'react';
import {memo, useContext} from 'react';
import styles from '../styles/fileUploader.module.scss';
import texts from '../../texts';
import {Uploader} from '../../../../../../components/FileUploader/uploader';
import {FileContext} from '../../../../../../components/FileUploader';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {formsStore} from '../../../../../../stores/Form/FormsStore';
import {createDataTestId} from '../../../../../../utils/dataTestId';

export const FileUploader = memo(() => {
    const {setFile} = useContext(FileContext);
    const uploaderEmptySerachState =
        !!formsStore?.currentScreen?.getActiveForm().getFastSearchQuery() &&
        !formsStore.currentScreen?.getActiveForm()?.records.filter(r => !r.isNew).length;

    return (
        <div
            className={
                uploaderEmptySerachState
                    ? styles.uploaderContainerWithSearch
                    : styles.uploaderContainer
            }
            {...createDataTestId(`uploader-wrapper`, false)}
        >
            <Uploader
                readOnly={false}
                file={null}
                setFile={setFile}
                componentClasses={styles.uploader}
                placeholder={`${texts.drop_file} ${texts.browse}`}
                icon={PriorityIcon.uploadCloud}
                multiple
                monitor={{send: true, text: 'AttachmentsDropFilesClick'}}
            />
        </div>
    );
});
